// import { Utils } from '@svb/api-content-component';
import { browseAPIhandler } from '../../helpers/browseAPIhandler';
import { getFileContent } from '../../helpers/utilityFunctions';

//get integration checklist from the contents repo
const getIntegrationChecklist = (url, fileName) => {
  // const token = localStorage.getItem('token');
  const { regenTokenandBrowse } = browseAPIhandler();
  const integrationChecklistData = getFileContent(
    `${url}?resourcePath=pages/integration-checklist&resourceName=${fileName}`,
    regenTokenandBrowse,
  );
  // if (integrationChecklistData.type === 'success') {
  return integrationChecklistData;
  // }
  // return 'No Content';
};

export { getIntegrationChecklist };
